import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';

class PageThankyou extends Component {

    render() {
        return (
            <Page primaryTitle="Contact" secondaryTitle="Thank You" section="">
                <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 PageThankyou">
                    <h3>Message Delivered</h3>
                    <p className="intro">Your message has been sent to SLA Service Management, and we will respond to your request promptly.</p>
                </div>
                <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                    <SideImage page={this.props.page} />
                </aside>
            </Page>
        );
    }
}

export default PageThankyou;



// WEBPACK FOOTER //
// ./src/pages/PageThankyou/PageThankyou.js